import { db, admin } from "common/config/Firebase"
import createIds from "./createIds"

const indicatorsByDay = db.collection('indicatorsByDay')
const indicatorsByMonth = db.collection('indicatorsByMonth')

const updateTask = ({ task, oldTask }) => {
    let increment = 0;

    if (task.budget !== oldTask.budget) {
        const currentBudget = isNaN(task.budget) ? 0 : Number(task.budget)
        const oldBudget = isNaN(oldTask.budget) ? 0 : Number(oldTask.budget)

        increment = currentBudget - oldBudget
    }

    incrementAmount(new Date(task.dateEntry), increment)
}

const addTask = (task) => {
    const increment = isNaN(task.budget) ? 0 : Number(task.budget)
    incrementAmount(new Date(task.dateEntry), increment)
}

const deleteTask = (task) => {
    const increment = isNaN(task.budget) ? 0 : 0 - Number(task.budget)
    incrementAmount(new Date(task.dateEntry), increment)
}

const incrementAmount = (date, amount) => {
    if (!amount) {
        return
    }

    const increment = admin.firestore.FieldValue.increment(amount)
    try {
        indicatorsByDay.doc(createIds.createIdByDay(date)).set({ amountTask: increment }, { merge: true })
        indicatorsByMonth.doc(createIds.createIdByMonth(date)).set({ amountTask: increment }, { merge: true })
    } catch (ex) {
        console.error("Error al actualizar el indicatorsByDay")
    }
}

const isReparado = task => {
    return task.state === "2" || task.state === 2
}

export default {
    updateTask,
    deleteTask,
    addTask
}